import { Box, Stack, Tab, Tabs, Typography, TypographyProps, styled } from "@mui/material";

export const TabsRoot = styled(Box)(() => ({
  minWidth: 0,
  overflow: "hidden",
  width: "100%"
}));

export const TabsContainer = styled(Tabs)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  maxWidth: "100%",
  width: "100%",
  fontFamily: "Inter",
  fontWeight: "500",
  marginBottom: "2rem",
  "> .Mui-disabled": {
    display: "none"
  },
  ".MuiTab-textColorPrimary:not(.Mui-selected)": {
    color: theme.customColors.systemPrimary01
  },
  ".Mui-selected": {
    color: theme.customColors.accentVariantA
  },
  ".MuiTabs-indicator": {
    background: theme.customColors.accentVariantA,
    borderRadius: "1.5rem"
  }
}));

export const AgendaTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontSize: "0.875rem",
  letterSpacing: "0.0313em",
  fontWeight: 600,
  height: "1.5rem",
  minWidth: "3rem",
  marginLeft: "0.35rem",
  marginRight: "0.35rem",
  lineHeight: "1.5rem",
  borderBottom: `2px solid ${theme.customColors.border}`,
  "&.Mui-focusVisible": {
    border: `1px solid ${theme.customColors.accentVariantA}`
  }
}));

export const TabPanel = styled(Box)(() => ({
}));

export const EventsList = styled(Stack)(() => ({
  gap: "0.5rem",
  overflowY: "auto",
  paddingRight: "4px",
  maxHeight: "30rem"
}));

export const CardsList = styled(Stack)(() => ({
  background: "transparent",
  borderRadius: "0.5rem",
  gap: "0.5rem"
}));

export const DaySection = styled(Stack)(() => ({
  gap: "8px"
}));

export const DayHeader = styled(Stack)(({ theme }) => ({
  display: "flex",
  alignItems: "baseline",
  gap: "0.125rem",
  marginLeft: "0.5rem",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "start",
    gap: "3px"
  }
}));

export const DayTitle = styled(Typography)<TypographyProps & { $fontWeight?: number }>(({ theme, $fontWeight }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "1rem",
  fontWeight: $fontWeight ?? 600,
  lineHeight: "1.5rem",
  textTransform: "capitalize"
}));

export const DaySubtitle = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText, /*variabile precedentemente settata theme.customColors.textDisabled. è stata cambiata perchè viola le regole di contrasto dell'accessibilità */
  fontSize: "0.75rem",
  fontWeight: 400,
  lineHeight: "1rem"
}));

export const NoEventsText = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText, /*variabile precedentemente settata theme.customColors.textDisabled. è stata cambiata perchè viola le regole di contrasto dell'accessibilità */
  fontSize: "0.875rem",
  fontWeight: 400,
  padding: "0.75rem 0.5rem"
}));
